export { blogIndexMeta, blogPostMeta } from "./blogMeta.generated";
export type { BlogPostMeta } from "./blogMeta.generated";
import { blogPostMeta } from "./blogMeta.generated";

const postsBySlug = new Map(blogPostMeta.map((post) => [post.slug, post]));
export function findBlogPostMeta(slug: string) {
  return postsBySlug.get(slug) ?? null;
}
